import { BackgroundImage, Text, useIntl } from 'platform-components';
import React from 'react';

import { SidePanelHeader } from '../__header/side-panel__header';

export const SidePanelModeCopy = React.memo(() => {
    const intl = useIntl();
    const copyingLoaderUrl = intl.formatMessage({ id: 'lessonModal.cover.copying.loaderUrl' });

    return (
        <>
            <SidePanelHeader>
                <Text id="lessonView.sidePanel.copy.title" size={Text.SIZE.XL} weight={Text.WEIGHT.M} />
            </SidePanelHeader>
            <BackgroundImage.Container mix="side-panel__content">
                <BackgroundImage mix="side-panel__copying-loader" objectFit="cover" src={copyingLoaderUrl} />
            </BackgroundImage.Container>
        </>
    );
});
